import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a230d7a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-fields" }
const _hoisted_2 = { class: "c-field" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "lastName"
}, "お名前", -1))
const _hoisted_4 = { class: "c-field__body" }
const _hoisted_5 = { class: "c-field__input has-horizontal-item" }
const _hoisted_6 = { class: "c-field" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "lastKana"
}, "ふりがな", -1))
const _hoisted_8 = { class: "c-field__body" }
const _hoisted_9 = { class: "c-field__input has-horizontal-item" }
const _hoisted_10 = { class: "c-field" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "nickname"
}, "ニックネーム", -1))
const _hoisted_12 = { class: "c-field__body" }
const _hoisted_13 = { class: "c-field__input" }
const _hoisted_14 = { class: "c-field" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, [
  /*#__PURE__*/_createTextVNode("性別"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1))
const _hoisted_16 = { class: "c-field__body" }
const _hoisted_17 = { class: "c-field__radio" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender_female" }, "女性", -1))
const _hoisted_19 = { class: "c-field__radio" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender_male" }, "男性", -1))
const _hoisted_21 = { class: "c-field__radio" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender_other" }, "その他", -1))
const _hoisted_23 = { class: "c-field__radio" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "gender_noanswer" }, "回答しない", -1))
const _hoisted_25 = { class: "c-field" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, [
  /*#__PURE__*/_createTextVNode("誕生日"),
  /*#__PURE__*/_createElementVNode("span", { class: "required" }, "必須")
], -1))
const _hoisted_27 = { class: "c-field__body" }
const _hoisted_28 = { class: "c-field__select" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "NaN" }, "-", -1))
const _hoisted_30 = ["value"]
const _hoisted_31 = { class: "c-field__select" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "NaN" }, "-", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = { class: "c-field__select" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "NaN" }, "-", -1))
const _hoisted_36 = ["value"]
const _hoisted_37 = { class: "c-field" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "zipCode"
}, "郵便番号", -1))
const _hoisted_39 = { class: "c-field__body" }
const _hoisted_40 = { class: "c-field__input has-horizontal-item" }
const _hoisted_41 = { class: "c-field" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "prefecture"
}, "都道府県", -1))
const _hoisted_43 = { class: "c-field__body" }
const _hoisted_44 = { class: "c-field__select" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "" }, "選択してください", -1))
const _hoisted_46 = ["value"]
const _hoisted_47 = { class: "c-field" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "address"
}, "住所", -1))
const _hoisted_49 = { class: "c-field__body" }
const _hoisted_50 = { class: "c-field__input has-vertical-item" }
const _hoisted_51 = { class: "c-field" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "c-field__label",
  for: "tel"
}, "電話番号", -1))
const _hoisted_53 = { class: "c-field__body" }
const _hoisted_54 = { class: "c-field__input" }
const _hoisted_55 = { class: "c-field" }
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "結婚の有無", -1))
const _hoisted_57 = { class: "c-field__body" }
const _hoisted_58 = { class: "c-field__radio" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "married" }, "既婚", -1))
const _hoisted_60 = { class: "c-field__radio" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "single" }, "未婚", -1))
const _hoisted_62 = { class: "c-field" }
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "子供の有無", -1))
const _hoisted_64 = { class: "c-field__body" }
const _hoisted_65 = { class: "c-field__radio" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "yes" }, "有り", -1))
const _hoisted_67 = { class: "c-field__radio" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "no" }, "無し", -1))
const _hoisted_69 = { class: "c-field" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "血液型", -1))
const _hoisted_71 = { class: "c-field__body" }
const _hoisted_72 = { class: "c-field__radio" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "A" }, "A型", -1))
const _hoisted_74 = { class: "c-field__radio" }
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "B" }, "B型", -1))
const _hoisted_76 = { class: "c-field__radio" }
const _hoisted_77 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "O" }, "O型", -1))
const _hoisted_78 = { class: "c-field__radio" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "AB" }, "AB型", -1))
const _hoisted_80 = { class: "c-field__radio" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "unknown" }, "不明", -1))
const _hoisted_82 = { class: "c-field" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "c-field__label" }, "集英社の書籍についてのお知らせ を希望する", -1))
const _hoisted_84 = { class: "c-field__body" }
const _hoisted_85 = { class: "c-field__radio" }
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is_send_mail_magazine_enable" }, "希望する", -1))
const _hoisted_87 = { class: "c-field__radio" }
const _hoisted_88 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "is_send_mail_magazine_disable" }, "希望しない", -1))
const _hoisted_89 = { class: "ha-signup-profile__list" }
const _hoisted_90 = { class: "ha-signup-profile__listitem" }
const _hoisted_91 = /*#__PURE__*/_createTextVNode("・集英社ID利用規約")
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "ha-signup-profile__listitem" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www2.shueisha.co.jp/privacy/privacy.html",
    class: "c-link",
    target: "_blank"
  }, "・集英社プライバシーガイドライン")
], -1))
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ha-signup-profile__note" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "ha-signup-profile__discription" }, "上記のプライバシーガイドライン・各規約に同意のうえ")
], -1))
const _hoisted_94 = { class: "c-field has-submit" }
const _hoisted_95 = ["disabled"]
const _hoisted_96 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "入力内容を確認する", -1))
const _hoisted_97 = [
  _hoisted_96
]
const _hoisted_98 = {
  key: 2,
  class: "c-field has-submit has-mt"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"margin-top":"4rem"} }, null, -1))
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ログアウト", -1))
const _hoisted_101 = [
  _hoisted_100
]
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退会", -1))
const _hoisted_103 = [
  _hoisted_102
]
const _hoisted_104 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "パスワード変更", -1))
const _hoisted_105 = [
  _hoisted_104
]
const _hoisted_106 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "メールアドレス変更", -1))
const _hoisted_107 = [
  _hoisted_106
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    "validation-schema": _ctx.schema,
    ref: "formRef"
  }, {
    default: _withCtx(({ errors, meta }) => [
      _createElementVNode("fieldset", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_Field, {
                type: "text",
                id: "lastName",
                name: "lastName",
                modelValue: _ctx.userBase.baseInfo.lastName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userBase.baseInfo.lastName) = $event)),
                placeholder: "姓",
                autocomplete: "family-name"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "text",
                id: "firstName",
                name: "firstName",
                modelValue: _ctx.userBase.baseInfo.firstName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.userBase.baseInfo.firstName) = $event)),
                placeholder: "名",
                autocomplete: "given-name"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.lastName), 513), [
          [_vShow, errors.lastName]
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.firstName), 513), [
          [_vShow, errors.firstName]
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_Field, {
                type: "text",
                id: "lastKana",
                name: "lastKana",
                modelValue: _ctx.userBase.baseInfo.lastKana,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.userBase.baseInfo.lastKana) = $event)),
                placeholder: "せい"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "text",
                id: "firstKana",
                name: "firstKana",
                modelValue: _ctx.userBase.baseInfo.firstKana,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.userBase.baseInfo.firstKana) = $event)),
                placeholder: "めい"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.lastKana), 513), [
          [_vShow, errors.lastKana]
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.firstKana), 513), [
          [_vShow, errors.firstKana]
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Field, {
                type: "text",
                id: "nickname",
                name: "nickname",
                modelValue: _ctx.userBase.commonAttrInfo.nickName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.userBase.commonAttrInfo.nickName) = $event)),
                placeholder: "○○○○○○○○"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.nickname), 513), [
          [_vShow, errors.nickname]
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "gender_female",
                name: "gender",
                value: "女性",
                modelValue: _ctx.userBase.commonAttrInfo.gender,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event)),
                required: ""
              }, null, 8, ["modelValue"]),
              _hoisted_18
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "gender_male",
                name: "gender",
                value: "男性",
                modelValue: _ctx.userBase.commonAttrInfo.gender,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event)),
                required: ""
              }, null, 8, ["modelValue"]),
              _hoisted_20
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "gender_other",
                name: "gender",
                value: "その他",
                modelValue: _ctx.userBase.commonAttrInfo.gender,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event)),
                required: ""
              }, null, 8, ["modelValue"]),
              _hoisted_22
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "gender_noanswer",
                name: "gender",
                value: "無回答",
                modelValue: _ctx.userBase.commonAttrInfo.gender,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.userBase.commonAttrInfo.gender) = $event)),
                required: ""
              }, null, 8, ["modelValue"]),
              _hoisted_24
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.gender), 513), [
          [_vShow, errors.gender]
        ]),
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _withDirectives(_createElementVNode("select", {
                ref: "yearRef",
                name: "year",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.date.year) = $event)),
                required: "",
                onMouseup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.birthdayValidate()))
              }, [
                _hoisted_29,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: idx,
                    value: year
                  }, _toDisplayString(year), 9, _hoisted_30))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.date.year]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _withDirectives(_createElementVNode("select", {
                ref: "monthRef",
                name: "month",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.date.month) = $event)),
                required: "",
                onMouseup: _cache[12] || (_cache[12] = ($event: any) => (_ctx.birthdayValidate()))
              }, [
                _hoisted_32,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: idx,
                    value: month
                  }, _toDisplayString(month), 9, _hoisted_33))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.date.month]
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _withDirectives(_createElementVNode("select", {
                ref: "dayRef",
                name: "day",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.date.day) = $event)),
                required: "",
                onMouseup: _cache[14] || (_cache[14] = ($event: any) => (_ctx.birthdayValidate()))
              }, [
                _hoisted_35,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dates, (date, idx) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: idx,
                    value: date
                  }, _toDisplayString(date), 9, _hoisted_36))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.date.day]
              ])
            ]),
            _createElementVNode("div", null, [
              _createVNode(_component_Field, {
                type: "text",
                name: "birthday",
                modelValue: _ctx.birthday,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.birthday) = $event)),
                style: {"display":"none"}
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.birthday), 513), [
          [_vShow, errors.birthday]
        ]),
        _createElementVNode("div", _hoisted_37, [
          _hoisted_38,
          _createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", _hoisted_40, [
              _createVNode(_component_Field, {
                type: "text",
                id: "zipCode",
                name: "zipCode",
                modelValue: _ctx.userBase.baseInfo.zipCode,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.userBase.baseInfo.zipCode) = $event)),
                placeholder: "0000000",
                autocomplete: "postal-code"
              }, null, 8, ["modelValue"]),
              _createElementVNode("a", {
                class: "c-link c-link--primary",
                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addressAutoFill()))
              }, "住所を検索する")
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.zipCode), 513), [
          [_vShow, errors.zipCode]
        ]),
        _createElementVNode("div", _hoisted_41, [
          _hoisted_42,
          _createElementVNode("div", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createVNode(_component_Field, {
                as: "select",
                id: "prefecture",
                name: "prefecture",
                modelValue: _ctx.userBase.baseInfo.prefecture,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.userBase.baseInfo.prefecture) = $event)),
                autocomplete: "address-level1"
              }, {
                default: _withCtx(() => [
                  _hoisted_45,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.prefectureList, (item, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: item
                    }, _toDisplayString(item), 9, _hoisted_46))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.prefecture), 513), [
          [_vShow, errors.prefecture]
        ]),
        _createElementVNode("div", _hoisted_47, [
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _createVNode(_component_Field, {
                type: "text",
                id: "address",
                name: "address",
                modelValue: _ctx.userBase.baseInfo.address,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.userBase.baseInfo.address) = $event)),
                placeholder: "市区町村番地",
                autocomplete: "address-line1"
              }, null, 8, ["modelValue"]),
              _createVNode(_component_Field, {
                type: "text",
                id: "building",
                name: "building",
                modelValue: _ctx.userBase.baseInfo.building,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.userBase.baseInfo.building) = $event)),
                placeholder: "建物（階数, 部屋番号）"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.address), 513), [
          [_vShow, errors.address]
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.building), 513), [
          [_vShow, errors.building]
        ]),
        _createElementVNode("div", _hoisted_51, [
          _hoisted_52,
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createVNode(_component_Field, {
                type: "text",
                id: "tel",
                name: "tel",
                modelValue: _ctx.userBase.baseInfo.tel,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.userBase.baseInfo.tel) = $event)),
                placeholder: "00012345678",
                autocomplete: "tel"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.tel), 513), [
          [_vShow, errors.tel]
        ]),
        _createElementVNode("div", _hoisted_55, [
          _hoisted_56,
          _createElementVNode("div", _hoisted_57, [
            _createElementVNode("div", _hoisted_58, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "married",
                name: "isMarried",
                value: true,
                modelValue: _ctx.userBase.commonAttrInfo.isMarried,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.userBase.commonAttrInfo.isMarried) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_59
            ]),
            _createElementVNode("div", _hoisted_60, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "single",
                name: "isMarried",
                value: false,
                modelValue: _ctx.userBase.commonAttrInfo.isMarried,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.userBase.commonAttrInfo.isMarried) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_61
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.isMarried), 513), [
          [_vShow, errors.isMarried]
        ]),
        _createElementVNode("div", _hoisted_62, [
          _hoisted_63,
          _createElementVNode("div", _hoisted_64, [
            _createElementVNode("div", _hoisted_65, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "yes",
                name: "hasChild",
                value: true,
                modelValue: _ctx.userBase.commonAttrInfo.hasChild,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.userBase.commonAttrInfo.hasChild) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_66
            ]),
            _createElementVNode("div", _hoisted_67, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "no",
                name: "hasChild",
                value: false,
                modelValue: _ctx.userBase.commonAttrInfo.hasChild,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.userBase.commonAttrInfo.hasChild) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_68
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.hasChild), 513), [
          [_vShow, errors.hasChild]
        ]),
        _createElementVNode("div", _hoisted_69, [
          _hoisted_70,
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("div", _hoisted_72, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "A",
                name: "bloodType",
                value: "A",
                modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_73
            ]),
            _createElementVNode("div", _hoisted_74, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "B",
                name: "bloodType",
                value: "B",
                modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_75
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "O",
                name: "bloodType",
                value: "O",
                modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_77
            ]),
            _createElementVNode("div", _hoisted_78, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "AB",
                name: "bloodType",
                value: "AB",
                modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_79
            ]),
            _createElementVNode("div", _hoisted_80, [
              _createVNode(_component_Field, {
                type: "radio",
                id: "unknown",
                name: "bloodType",
                value: "不明",
                modelValue: _ctx.userBase.commonAttrInfo.bloodType,
                "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.userBase.commonAttrInfo.bloodType) = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_81
            ])
          ])
        ]),
        _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.bloodType), 513), [
          [_vShow, errors.bloodType]
        ]),
        (!_ctx.firstLoginAfterMgn)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_82, [
                _hoisted_83,
                _createElementVNode("div", _hoisted_84, [
                  _createElementVNode("div", _hoisted_85, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      id: "is_send_mail_magazine_enable",
                      name: "isSendMailMagazine",
                      value: true,
                      modelValue: _ctx.userShueishaPublication.isSendMailMagazine,
                      "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.userShueishaPublication.isSendMailMagazine) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_86
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createVNode(_component_Field, {
                      type: "radio",
                      id: "is_send_mail_magazine_disable",
                      name: "isSendMailMagazine",
                      value: false,
                      modelValue: _ctx.userShueishaPublication.isSendMailMagazine,
                      "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.userShueishaPublication.isSendMailMagazine) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_88
                  ])
                ])
              ]),
              _withDirectives(_createElementVNode("span", { class: "c-error" }, _toDisplayString(errors.isSendMailMagazine), 513), [
                [_vShow, errors.isSendMailMagazine]
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.firstServiceReg)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("ul", _hoisted_89, [
                _createElementVNode("li", _hoisted_90, [
                  _createVNode(_component_router_link, {
                    tag: "a",
                    to: { name: 'Terms' },
                    class: "c-link",
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_91
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_92
              ]),
              _hoisted_93
            ], 64))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_94, [
          _createElementVNode("button", {
            class: "ha-btn is-submit",
            type: "button",
            onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.moveConfirm && _ctx.moveConfirm(...args))),
            disabled: !meta.valid
          }, _hoisted_97, 8, _hoisted_95)
        ]),
        (_ctx.isDispButton)
          ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
              _hoisted_99,
              _createElementVNode("button", {
                class: "ha-btn is-submit",
                type: "button",
                onClick: _cache[34] || (_cache[34] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
              }, _hoisted_101),
              _createElementVNode("button", {
                class: "ha-btn is-submit",
                type: "button",
                onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.moveWithdrowal && _ctx.moveWithdrowal(...args)))
              }, _hoisted_103),
              _createElementVNode("button", {
                class: "ha-btn is-submit",
                type: "button",
                onClick: _cache[36] || (_cache[36] = 
//@ts-ignore
(...args) => (_ctx.moveChangePassword && _ctx.moveChangePassword(...args)))
              }, _hoisted_105),
              _createElementVNode("button", {
                class: "ha-btn is-submit",
                type: "button",
                onClick: _cache[37] || (_cache[37] = 
//@ts-ignore
(...args) => (_ctx.moveChangeEmail && _ctx.moveChangeEmail(...args)))
              }, _hoisted_107)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}